// extracted by mini-css-extract-plugin
module.exports = {"Todo":"Todo_Todo__B4yGm","Star":"Todo_Star__1saA9","Expired":"Todo_Expired__2oqer"};